export const team = JSON.parse(`{
    "id": "GN7VASH15HKYQA7",
    "name": "México",
    "nameAbbrev": "MEX",
    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2228.png",
    "logo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3010.png"
}`)


// WEBPACK FOOTER //
// ./src/mundial/requests/mockData/team.ts